'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _applyNativeMethods = require('../../modules/applyNativeMethods');

var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);

var _createElement = require('../createElement');

var _createElement2 = _interopRequireDefault(_createElement);

var _AssetRegistry = require('../../modules/AssetRegistry');

var _ImageLoader = require('../../modules/ImageLoader');

var _ImageLoader2 = _interopRequireDefault(_ImageLoader);

var _ImageResizeMode = require('./ImageResizeMode');

var _ImageResizeMode2 = _interopRequireDefault(_ImageResizeMode);

var _ImageStylePropTypes = require('./ImageStylePropTypes');

var _ImageStylePropTypes2 = _interopRequireDefault(_ImageStylePropTypes);

var _ImageUriCache = require('./ImageUriCache');

var _ImageUriCache2 = _interopRequireDefault(_ImageUriCache);

var _requestIdleCallback = require('../../modules/requestIdleCallback');

var _requestIdleCallback2 = _interopRequireDefault(_requestIdleCallback);

var _StyleSheet = require('../StyleSheet');

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _StyleSheetPropType = require('../../modules/StyleSheetPropType');

var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);

var _View = require('../View');

var _View2 = _interopRequireDefault(_View);

var _ViewPropTypes = require('../ViewPropTypes');

var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);

var _propTypes = require('prop-types');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016-present, Nicolas Gallagher.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @providesModule Image
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var emptyObject = {};

var STATUS_ERRORED = 'ERRORED';
var STATUS_LOADED = 'LOADED';
var STATUS_LOADING = 'LOADING';
var STATUS_PENDING = 'PENDING';
var STATUS_IDLE = 'IDLE';

var ImageSourcePropType = (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.shape)({
  height: _propTypes.number,
  uri: _propTypes.string.isRequired,
  width: _propTypes.number
}), _propTypes.string]);

var getImageState = function getImageState(uri, shouldDisplaySource) {
  return shouldDisplaySource ? STATUS_LOADED : uri ? STATUS_PENDING : STATUS_IDLE;
};

var resolveAssetDimensions = function resolveAssetDimensions(source) {
  if (typeof source === 'number') {
    var _getAssetByID = (0, _AssetRegistry.getAssetByID)(source),
        height = _getAssetByID.height,
        width = _getAssetByID.width;

    return { height: height, width: width };
  } else if (typeof source === 'object') {
    var _height = source.height,
        _width = source.width;

    return { height: _height, width: _width };
  }
};

var svgDataUriPattern = /^data:image\/svg\+xml;/;
var resolveAssetSource = function resolveAssetSource(source) {
  var uri = void 0;
  if (typeof source === 'number') {
    // get the URI from the packager
    var asset = (0, _AssetRegistry.getAssetByID)(source);
    var scale = asset.scales[0];
    var scaleSuffix = scale !== 1 ? '@' + scale + 'x' : '';
    uri = asset ? asset.httpServerLocation + '/' + asset.name + scaleSuffix + '.' + asset.type : '';
  } else if (source && source.uri) {
    uri = source.uri;
  } else {
    uri = source || '';
  }

  // SVG data may contain characters (e.g., #, ") that need to be escaped
  if (svgDataUriPattern.test(uri)) {
    var parts = uri.split('<svg');
    var prefix = parts[0],
        svgFragment = parts.slice(1);

    var svg = encodeURIComponent('<svg' + svgFragment.join('<svg'));
    return '' + prefix + svg;
  }

  return uri;
};

var getAssetTimeout = function getAssetTimeout(source) {
  return typeof source === 'object' && source.timeout ? source.timeout : 1000;
};

var Image = function (_Component) {
  _inherits(Image, _Component);

  Image.getSize = function getSize(uri, success, failure) {
    _ImageLoader2.default.getSize(uri, success, failure);
  };

  Image.prefetch = function prefetch(uri) {
    return _ImageLoader2.default.prefetch(uri);
  };

  function Image(props, context) {
    _classCallCheck(this, Image);

    // If an image has been loaded before, render it immediately
    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this._imageRequestId = null;
    _this._imageState = null;
    _this._isMounted = false;
    _this._loadRequest = null;

    _this._onError = function () {
      var _this$props = _this.props,
          onError = _this$props.onError,
          source = _this$props.source;

      _this._updateImageState(STATUS_ERRORED);
      if (onError) {
        onError({
          nativeEvent: {
            error: 'Failed to load resource ' + resolveAssetSource(source) + ' (404)'
          }
        });
      }
      _this._onLoadEnd();
    };

    _this._onLoad = function (e) {
      var _this$props2 = _this.props,
          onLoad = _this$props2.onLoad,
          source = _this$props2.source;

      var event = { nativeEvent: e };
      _ImageUriCache2.default.add(resolveAssetSource(source));
      _this._updateImageState(STATUS_LOADED);
      if (onLoad) {
        onLoad(event);
      }
      _this._onLoadEnd();
    };

    var uri = resolveAssetSource(props.source);
    var shouldDisplaySource = _ImageUriCache2.default.has(uri);
    _this.state = { shouldDisplaySource: shouldDisplaySource };
    _this._imageState = getImageState(uri, shouldDisplaySource);
    shouldDisplaySource && _ImageUriCache2.default.add(uri);
    return _this;
  }

  Image.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this._imageState === STATUS_PENDING) {
      this._createImageLoader();
    } else if (this._imageState === STATUS_LOADED) {
      var onLoad = this.props.onLoad;

      onLoad && onLoad();
    }
  };

  Image.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this._imageState === STATUS_PENDING) {
      this._createImageLoader();
    }
  };

  Image.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var uri = resolveAssetSource(this.props.source);
    var nextUri = resolveAssetSource(nextProps.source);
    if (uri !== nextUri) {
      _ImageUriCache2.default.remove(uri);
      var isPreviouslyLoaded = _ImageUriCache2.default.has(nextUri);
      isPreviouslyLoaded && _ImageUriCache2.default.add(uri);
      this._updateImageState(getImageState(uri, isPreviouslyLoaded));
    }
  };

  Image.prototype.componentWillUnmount = function componentWillUnmount() {
    _ImageUriCache2.default.remove(resolveAssetSource(this.props.source));
    this._destroyImageLoader();
    this._isMounted = false;
  };

  Image.prototype.render = function render() {
    var shouldDisplaySource = this.state.shouldDisplaySource;

    var _props = this.props,
        accessibilityLabel = _props.accessibilityLabel,
        accessible = _props.accessible,
        defaultSource = _props.defaultSource,
        draggable = _props.draggable,
        onLayout = _props.onLayout,
        source = _props.source,
        testID = _props.testID,
        blurRadius = _props.blurRadius,
        capInsets = _props.capInsets,
        onError = _props.onError,
        onLoad = _props.onLoad,
        onLoadEnd = _props.onLoadEnd,
        onLoadStart = _props.onLoadStart,
        resizeMethod = _props.resizeMethod,
        resizeMode = _props.resizeMode,
        other = _objectWithoutProperties(_props, ['accessibilityLabel', 'accessible', 'defaultSource', 'draggable', 'onLayout', 'source', 'testID', 'blurRadius', 'capInsets', 'onError', 'onLoad', 'onLoadEnd', 'onLoadStart', 'resizeMethod', 'resizeMode']);

    var displayImage = resolveAssetSource(shouldDisplaySource ? source : defaultSource);
    var imageSizeStyle = resolveAssetDimensions(shouldDisplaySource ? source : defaultSource);
    var backgroundImage = displayImage ? 'url("' + displayImage + '")' : null;
    var originalStyle = _StyleSheet2.default.flatten(this.props.style);
    var finalResizeMode = resizeMode || originalStyle.resizeMode || _ImageResizeMode2.default.cover;

    var style = _StyleSheet2.default.flatten([styles.initial, imageSizeStyle, originalStyle, resizeModeStyles[finalResizeMode], this.context.isInAParentText && styles.inline, backgroundImage && { backgroundImage: backgroundImage }]);
    // View doesn't support these styles
    delete style.overlayColor;
    delete style.resizeMode;
    delete style.tintColor;

    // Allows users to trigger the browser's image context menu
    var hiddenImage = displayImage ? (0, _createElement2.default)('img', {
      alt: accessibilityLabel || '',
      draggable: draggable,
      src: displayImage,
      style: styles.img
    }) : null;

    if (process.env.NODE_ENV !== 'production') {
      if (this.props.src) {
        console.warn('The <Image> component requires a `source` property rather than `src`.');
      }

      if (this.props.children) {
        throw new Error('The <Image> component cannot contain children. If you want to render content on top of the image, consider using the <ImageBackground> component or absolute positioning.');
      }
    }

    return _react2.default.createElement(
      _View2.default,
      _extends({}, other, {
        accessibilityLabel: accessibilityLabel,
        accessible: accessible,
        onLayout: onLayout,
        style: style,
        testID: testID
      }),
      hiddenImage
    );
  };

  Image.prototype._createImageLoader = function _createImageLoader() {
    var _this2 = this;

    var source = this.props.source;

    this._destroyImageLoader();
    this._loadRequest = (0, _requestIdleCallback2.default)(function () {
      var uri = resolveAssetSource(source);
      _this2._imageRequestId = _ImageLoader2.default.load(uri, _this2._onLoad, _this2._onError);
      _this2._onLoadStart();
    }, { timeout: getAssetTimeout(source) });
  };

  Image.prototype._destroyImageLoader = function _destroyImageLoader() {
    if (this._loadRequest) {
      (0, _requestIdleCallback.cancelIdleCallback)(this._loadRequest);
      this._loadRequest = null;
    }

    if (this._imageRequestId) {
      _ImageLoader2.default.abort(this._imageRequestId);
      this._imageRequestId = null;
    }
  };

  Image.prototype._onLoadEnd = function _onLoadEnd() {
    var onLoadEnd = this.props.onLoadEnd;

    if (onLoadEnd) {
      onLoadEnd();
    }
  };

  Image.prototype._onLoadStart = function _onLoadStart() {
    var onLoadStart = this.props.onLoadStart;

    this._updateImageState(STATUS_LOADING);
    if (onLoadStart) {
      onLoadStart();
    }
  };

  Image.prototype._updateImageState = function _updateImageState(status) {
    this._imageState = status;
    var shouldDisplaySource = this._imageState === STATUS_LOADED || this._imageState === STATUS_LOADING;
    // only triggers a re-render when the image is loading (to support PJEG), loaded, or failed
    if (shouldDisplaySource !== this.state.shouldDisplaySource) {
      if (this._isMounted) {
        this.setState(function () {
          return { shouldDisplaySource: shouldDisplaySource };
        });
      }
    }
  };

  return Image;
}(_react.Component);

Image.displayName = 'Image';
Image.contextTypes = {
  isInAParentText: _propTypes.bool
};
Image.defaultProps = {
  style: emptyObject
};
Image.resizeMode = _ImageResizeMode2.default;
Image.propTypes = process.env.NODE_ENV !== "production" ? Object.assign({}, _ViewPropTypes2.default, {
  defaultSource: ImageSourcePropType,
  draggable: _propTypes.bool,
  onError: _propTypes.func,
  onLayout: _propTypes.func,
  onLoad: _propTypes.func,
  onLoadEnd: _propTypes.func,
  onLoadStart: _propTypes.func,
  resizeMode: (0, _propTypes.oneOf)(Object.keys(_ImageResizeMode2.default)),
  source: ImageSourcePropType,
  style: (0, _StyleSheetPropType2.default)(_ImageStylePropTypes2.default),
  // compatibility with React Native
  /* eslint-disable react/sort-prop-types */
  blurRadius: _propTypes.number,
  capInsets: (0, _propTypes.shape)({ top: _propTypes.number, left: _propTypes.number, bottom: _propTypes.number, right: _propTypes.number }),
  resizeMethod: (0, _propTypes.oneOf)(['auto', 'resize', 'scale'])
  /* eslint-enable react/sort-prop-types */
}) : {};


var styles = _StyleSheet2.default.create({
  initial: {
    backgroundColor: 'transparent',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    zIndex: 0
  },
  inline: {
    display: 'inline-flex'
  },
  img: Object.assign({}, _StyleSheet2.default.absoluteFillObject, {
    height: '100%',
    opacity: 0,
    width: '100%',
    zIndex: -1
  })
});

var resizeModeStyles = _StyleSheet2.default.create({
  center: {
    backgroundSize: 'auto',
    backgroundPosition: 'center'
  },
  contain: {
    backgroundSize: 'contain'
  },
  cover: {
    backgroundSize: 'cover'
  },
  none: {
    backgroundSize: 'auto'
  },
  repeat: {
    backgroundSize: 'auto',
    backgroundRepeat: 'repeat'
  },
  stretch: {
    backgroundSize: '100% 100%'
  }
});

exports.default = (0, _applyNativeMethods2.default)(Image);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-native-web/dist/exports/Image/index.js
// module id = ./node_modules/react-native-web/dist/exports/Image/index.js
// module chunks = 0